import { Component, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ACLService, HelperService } from 'app/services';
import { environment } from 'environments/environment';
import { CookieService } from 'ngx-cookie';


@Component({
  selector: 'app-navigate-company-view',
  template: '',
})
export class NavigateCompanyViewComponent implements OnInit {

  token: any;

  constructor(private activatedRoute: ActivatedRoute, private cookieService: CookieService,
    private router: Router, private aclService: ACLService, private helperService: HelperService,){}

  ngOnInit(): void {
    this.token = this.activatedRoute.snapshot.paramMap.get('token');
    const ssoToken: any = this.activatedRoute.snapshot.paramMap.get('sso');
    this.cookieService.putObject('alpatsso', ssoToken, environment.cookieOption);
    
    this.setLoginSetting({
        token: this.token,
        isRecentRoleChange: false,
        isFirstLogin: false,
        isNeededClockIn: false,
    });
  }

  setLoginSetting({ token, isRecentRoleChange, isFirstLogin, isNeededClockIn }) {
    // set token in cookie
    this.cookieService.putObject('alpat', token, environment.cookieOption);
    
    // if tech is not clocked in then navigate to clock screen
    if (isNeededClockIn) {
      this.router.navigate(['/tech/clock']);
      return;
    }

    // navigate to entry point
    this.router.navigate([this.aclService.getEntry(this.helperService.jwtDecode(token).role)]);
  }

}